export const AddToCartMessages = {
  AddSuccess: 'Услуга добавлена <br/>в предварительный заказ',
  ErrorTitle: 'Произошла ошибка',
  ErrorMessage: 'Пожалуйста, повторите попытку позже',
  CannotPreorderMessage:
    'Эту услугу можно заказать только в Диагностическом центре или по телефону справочной службы',
  CannotPreorderHelixLiteMessage:
    'Информацию о наличии услуги уточните в интересующем вас пункте Helix Lite',
};
